import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import CustomerHead from '../../components/customer/CustomerHead';
import { ResidentialServiceList } from '../../components/customer/ConsultList';
import { useState } from 'react';

export default function CustomerResidential(){

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1025);

  return (
    <ServiceWrap>
      <CustomerHead title='Residential Services' back={true}/>
      <main className="content">
        <section className="visual-sec">
          {!isMobile && (
            <img src="https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/background/residential_visual.webp" alt="visual" />
          )}
          {isMobile && (
            <img src="https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/background/m_residential.webp" alt="visual" />
          )}
        </section>
        <section className="service-wrap">
          <div className="inner">
            <div className="service-desc">
              <p>Keeping your home pest-free is essential for a safe and healthy living environment. At UST Pest Services, we provide effective, reliable, and customized residential pest control solutions to protect your home from unwanted intruders. Our expert team uses advanced techniques and a proven IREP Approach (Identifying, Reducing, Eliminating, Preventing) to ensure long-term pest prevention.</p>
              <p>Pests in commercial spaces can cause property damage, contamination, and health risks for employees and customers. Issues like rodent infestations, cockroach activity, and ant trails can lead to health code violations and customer complaints, ultimately affecting your business's reputation and revenue. Our commercial pest control services are tailored to address these issues effectively while ensuring minimal disruption to your daily operations.</p>
            </div>
            <div className="service-list">
              {ResidentialServiceList.map(({ title, desc, link }, idx) => (
                <Link to={link} key={idx} className={`service-item item-${idx + 1}`} category="residentiall">
                  <div className="list-in">
                    <strong>{title}</strong>
                    <p>{desc}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
        <section className="approach-visual">
          <div className="visual-img">
            {isMobile && (
              <img src="https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/service/residential_bg.webp" alt="approach-img" />
            )}
          </div>
          <div className="visual-desc">
            <div className="desc-head">
              <strong>IREP Approach</strong>
              <p>We follow a specialized IREP Approach to ensure effective pest management:</p>
            </div>
            <div className="desc-content">
              <img src="https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/service/approach-img.webp" alt="arep" />
            </div>
          </div>
        </section>
        <section className="approach-info">
          <div className="inner">
            <div className="info-desc">
              <strong className="info-tit">At UST Pest Services, we follow the <em>IREP</em> <span>(Identifying, Reducing, Eliminating, Preventing)</span> approach, a systematic method to ensure effective and long-term pest control.</strong>
              <ul className="info-list">
                <li className="info-item">
                  <strong>1. Identifying (I) - Identifying Pest Entry Points</strong>
                  <p>The first step is to inspect and identify how pests are entering your space. This includes checking for gaps in doors, cracks in walls, drainage openings, and ventilation gaps. We do not seal these points but provide a detailed report on the areas that need to be fixed to prevent pest entry.</p>
                </li>
                <li className="info-item">
                  <strong>2. Reducing (R) - Reducing Pest Attractions</strong>
                  <p>The first step is to inspect and identify how pests are entering your space. This includes checking for gaps in doors, cracks in walls, drainage openings, and ventilation gaps. We do not seal these points but provide a detailed report on the areas that need to be fixed to prevent pest entry.</p>
                </li>
                <li className="info-item">
                  <strong>3. Eliminating (E) - Eliminating Existing Pests</strong>
                  <p>The first step is to inspect and identify how pests are entering your space. This includes checking for gaps in doors, cracks in walls, drainage openings, and ventilation gaps. We do not seal these points but provide a detailed report on the areas that need to be fixed to prevent pest entry.</p>
                </li>
                <li className="info-item">
                  <strong>4. Preventing (P) - Preventing Future Infestations</strong>
                  <p>The first step is to inspect and identify how pests are entering your space. This includes checking for gaps in doors, cracks in walls, drainage openings, and ventilation gaps. We do not seal these points but provide a detailed report on the areas that need to be fixed to prevent pest entry.</p>
                </li>
              </ul>
              <p className="info-foot">For safe and expert pest control services, trust UST Pest Services - bringing advanced Korean techniques to India for a clean and pest-free space!</p>
            </div>
            <div className="info-include">
              <strong>Our Residential Pest Control Services Include:</strong>
              <ul>
                <li>General Pest Control (Ants, Cockroaches, Flies)</li>
                <li>Rodent Control & Exclusion</li>
                <li>Termite Inspections & Treatments</li>
                <li>Wood Borer Treatment</li>
                <li>Bed Bug Elimination</li>
                <li>Mosquitoes & Flea Control</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </ServiceWrap>
  )
}

const ServiceWrap = styled.div`
  position: relative;
  background: #F9FAFB;
  
  .content {
    position:relative;
    padding: 20px 20px 80px 20px;

    .visual-sec {
      position: relative;
      width: 100%;

      img {
        width: 100%;
      }
    }

    .service-wrap {
      position: relative;
      padding: 100px 0;

      .service-desc {
        position: relative;
        text-align: center;

        p {
          display: block;
          font-weight: 400;
          font-size: 24px;
          line-height: 1.5;
          color: #000;
        }

        p + p {
          margin-top: 60px;
        }
      }

      .service-list {
        margin-top: 60px;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        gap: 60px 120px;

        .service-item {
          position: relative;
          width: calc(33.33% - 80px);
          min-height: 305px;
          padding: 20px;
          border-radius: 30px;
          border: 5px solid #fff;
          background: #0072B9;
          filter: drop-shadow(10px 10px 1px rgba(0, 0, 0, 0.2));
          text-align: center;

          &:hover::before {
            z-index: 1;
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.75);
            border-radius: 30px;
          }

          ${[...Array(9)].map(
                  (_, i) => css`
              &.item-${i + 1}:hover {
                background: url("https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/space/space_${
                          10 + i
                  }.webp") no-repeat;
                background-size: cover;
              }
            `
          )}
          .list-in {
            z-index: 2;
            position: relative;

            strong {
              font-weight: 600;
              font-size: 24px;
              color: #fff;
            }

            p {
              margin-top: 15px;
              display: block;
              font-weight: 400;
              font-size: 18px;
              line-height: 1.5;
              color: #fff;
            }
          }
        }
      }
    }

    .approach-visual {
      position: relative;
      display: flex;

      .visual-img, .visual-desc {
        flex: 1;
      }

      .visual-img {
        height: auto;
        background: url("https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/service/residential_bg.webp") 50% 50% no-repeat;
      }

      .visual-desc {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 50px 0;
        gap: 60px 0;

        .desc-head {
          position: relative;
          text-align: center;

          strong {
            display: inline-block;
            font-weight: 400;
            font-size: 48px;
            padding-bottom: 10px;
            border-bottom: 1px solid #000;
          }

          p {
            margin-top: 15px;
            display: block;
            font-size: 24px;
            line-height: 1.5;
            color: #000;
          }
        }

        .desc-content {
          position: relative;
          text-align: center;

          img {
            max-width: 75%;
          }
        }
      }
    }

    .approach-info {
      position: relative;
      padding: 100px 0;

      .info-tit {
        font-weight: 400;
        font-size: 24px;
        line-height: 1.5;
        color: #000;

        em {
          font-weight: 700;
          color: #0072B9;
        }

        span {
          font-weight: 700;
        }
      }

      ul {
        margin-top: 50px;

        li {
          position: relative;

          strong {
            font-weight: 700;
            font-size: 24px;
            color: #0072B9;
          }

          p {
            font-weight: 400;
            font-size: 24px;
            line-height: 1.5;
            color: #000;
          }
        }

        .info-item + .info-item {
          margin-top: 50px;
        }
      }

      .info-foot {
        margin-top: 50px;
        display: block;
        font-weight: 400;
        font-size: 24px;
        line-height: 1.5;
        color: #000;
      }

      .info-include {
        margin-top: 100px;
        position: relative;

        strong {
          display: inline-block;
          padding-bottom: 10px;
          font-weight: 400;
          font-size: 48px;
          color: #000;
          border-bottom: 1px solid #000;
        }

        ul {
          margin-top: 20px;
          position: relative;

          li {
            list-style: disc;
            margin-left: 20px;
            font-weight: 400;
            font-size: 24px;
            line-height: 1.5;
            color: #000;
          }
        }
      }
    }

    @media only screen and (max-width: 1024px) {
      .service-wrap {
        padding: 40px 0 80px;

        .service-desc {
          text-align: left;

          p {
            font-size: 18px;
          }

          p + p {
            margin-top: 30px;
          }
        }

        .service-list {
          margin-top: 30px;
          display: block;

          .service-item {
            display: block;
            position: relative;
            width: 50%;
            margin: 0 auto;
            min-height: auto;

            strong {
              font-weight: 600;
              font-size: 24px;
              color: #fff;
            }

            p {
              margin-top: 15px;
              display: block;
              font-weight: 400;
              font-size: 18px;
              line-height: 1.5;
              color: #fff;
            }
          }

          .service-item + .service-item {
            margin-top: 60px;
          }
        }
      }

      .approach-visual {
        position: relative;
        padding: 50px 20px;
        background: rgba(217, 217, 217, 0.7);
        display: block;

        .visual-img, .visual-desc {
          width: 100%;
        }

        .visual-img {
          height: auto;
          background: none;

          img {
            width: 100%;
          }
        }

        .visual-desc {
          margin-top: 25px;
          padding: 0;
          gap: 30px 0;

          .desc-head {
            position: relative;
            text-align: center;

            strong {
              font-size: 32px;
            }

            p {
              font-size: 16px;
            }
          }

          .desc-content {
            position: relative;
            text-align: center;
          }
        }
      }

      .approach-info {
        position: relative;
        padding: 40px 0;

        .info-tit {
          font-size: 16px;
        }

        ul {
          margin-top: 25px;

          li {
            position: relative;

            strong {
              font-size: 18px;
            }

            p {
              font-size: 16px;
            }
          }

          .info-item + .info-item {
            margin-top: 25px;
          }
        }

        .info-foot {
          margin-top: 25px;
          font-size: 16px;
        }

        .info-include {
          margin-top: 50px;

          strong {
            font-size: 28px;
          }

          ul {
            margin-top: 10px;
            position: relative;

            li {
              font-size: 16px;
            }
          }
        }
      }
    }

    @media only screen and (max-width: 640px) {

      .service-wrap {
        .service-list {
          .service-item {
            width: 100%;
          }
        }
      }

      .approach-info {
        .info-include {
          strong {
            font-size: 20px;
          }
        }
      }
    }
  \`
  }
`